import styled, { css } from "styled-components";
import { Icon } from "@ddm-design-system/icon";

export const CloseIcon = styled(Icon).attrs({ name: "Close", size: 16 })(
  ({ theme }) => css`
    cursor: pointer;
    padding-left: ${theme.spaceUnit.xs};
  `
);
